export const KM_ABREVIATION = 'km';
export const M_ABREVIATION = 'm';
